import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import styles from "./style.module.css";

import { LandingCard, MessageBox } from "../../../ui_elements";
import { Banner, LandingModal } from "./containers";
import link1 from "../../../assets/svgs/link1.svg";
import link3 from "../../../assets/svgs/link3.svg";
import { useApiGet } from "../../../api/apiCall";
import { getRecentNoticessUrl } from "../../../api/urls";
import { useHistory } from "react-router-dom";
import NotificationBanner from "./notification";

const LandingPage = () => {
	const [message, setMessage] = useState(true);
	const [modal, setModal] = useState(false);

	const { push } = useHistory();

	// const handleCurrentLink = (linkObject) => {
	// 	if (linkObject?.applicationMode === "1") {
	// 		push({
	// 			pathname: `/generate_jamb_students_invoice`,
	// 			state: { application: linkObject }
	// 		});
	// 	} else if (linkObject?.applicationMode === "2") {
	// 		push({
	// 			pathname: `/generate_other_students_invoice`,
	// 			state: { application: linkObject }
	// 		});
	// 	} else {
	// 		const errorFlag = window.AJS.flag({
	// 			type: "error",
	// 			title: "Invalid Action!",
	// 			body: "Not a valid application mode"
	// 		});
	// 		setTimeout(() => {
	// 			errorFlag.close();
	// 		}, 5000);
	// 	}
	// };

	// let applicationForms = {
	// 	postUme: {
	// 		applicationMode: "1",
	// 		id: "1",
	// 		name: "POST UTME APPLICATION "
	// 	},
	// 	jupeb: { applicationMode: "2", id: "5", name: "JUPEB APPLICATION" },
	// 	part_time: {
	// 		applicationMode: "2",
	// 		id: "6",
	// 		name: "PART-TIME SALE OF FORMS"
	// 	},
	// 	postgraduate: {
	// 		applicationMode: "2",
	// 		id: "7",
	// 		name: "POSTGRADUATE APPLICATION"
	// 	},
	// 	direct_entry: {
	// 		applicationMode: "1",
	// 		id: "9",
	// 		name: "DIRECT ENTRY APPLICATION"
	// 	}
	// };

	const { data, isFetched } = useApiGet(getRecentNoticessUrl(), {
		keepPreviousData: true
	});

	useEffect(() => {
		if (isFetched) {
			setModal(true);
		}
	}, [isFetched]);

	return (
		<>
			{!data?.data || data?.data.length === 0 ? null : (
				<LandingModal
					data={data?.data}
					isOpen={modal}
					closeModal={() => setModal(false)}
				/>
			)}
			{!data?.data ||
			data?.data?.length === 0 ||
			message === false ? null : (
				<MessageBox
					openModal={() => setModal(true)}
					closeMessage={setMessage}
					title={data?.data[0]?.title}
					message={
						<div
							className={`d-flex align-items-baseline ${styles.message_body}`}
						>
							<div
								dangerouslySetInnerHTML={{
									__html: DOMPurify.sanitize(
										data?.data[0]?.description.slice(0, 70)
									)
								}}
							/>
							<span>....</span>
						</div>
					}
				/>
			)}
			<NotificationBanner />
			<Banner />

			<div className={styles.programs_wrapper}>
				<div className={styles.programs_title}>
					<h3 className="text-center">
						Programmes, Applications and Payments
					</h3>
					<p className="text-center">
						Find all our authenticated applications and
						registrations below for various student
						<br /> types and programmes
					</p>
				</div>
				<div
					id="application_container"
					className={`${styles.program_container} d-flex justify-content-between`}
				>
					<div className={styles.program_card}>
						<LandingCard
							img={link1}
							title={"New Students"}
							info={"Important links for new students"}
						>
							<p
								className="landing_card_link"
								onClick={() => push("admission_process_flow")}
							>
								Admission process flow
							</p>
							<p
								onClick={() => push("prospective_students")}
								className="landing_card_link"
							>
								Check Admission Status
							</p>
						</LandingCard>
					</div>

					<div className={styles.program_card}>
						<LandingCard
							img={link3}
							title={"Application forms"}
							info={"Links to the various application forms."}
						>
							<p
								className="landing_card_link"
								onClick={() => push("/create_account")}
							>
								Click Here to Apply
							</p>
						</LandingCard>
					</div>
				</div>
			</div>
		</>
	);
};

export default LandingPage;
